module.exports = __webpack_public_path__ + "media/images/emblems/Pieterlen-coat_of_arms-c2ed7f64038ffb185695877cfca0f315.svg";